import HCLDX from "@system/config/hcldx";
import Common from "../../src/pages/Order/Common";
import CommonOrderDetail from "src/pages/Order/OrderDetail/CommonOrderDetail";
import System from "../../src/helper/system";
import $ from "jquery";
import Helper from "src/support/Helper";

let c = System.getParams();

class Order {
    static ORDER_LISTING = Helper.getOrderUrl() + '/api/order/list';
    static HEADER_ORDER_DETAIL = Helper.getOrderUrl() + '/api/order/headerDetails';
    static ORDER_EMAIL = Helper.getOrderUrl() + '/api/order/emailOrder';
    static ORDER_EMAIL_SALES_REPRESENTATIVE = Helper.getOrderUrl() + '/api/order/emailSalesRepresentative';
    static ORDER_BY_LINE_ITEM = Helper.getOrderUrl() + '/api/order/orderLinesByItems';
    static ORDER_BY_DELIVERY = Helper.getOrderUrl() + '/api/order/orderLinesByShipments';
    static PLACE_YOUR_ORDER = Helper.getOrderUrl() + '/api/order/placeOrder';
    static PLACE_ORDER_ITEMS = Helper.getOrderUrl() + '/api/order/orderItems';
    static ORDER_DOWNLOAD_SINGLE_INVOICE = Helper.getOrderUrl() + '/api/cart/invoice/download';
    static EXPORT_ORDER = Helper.getOrderUrl() + '/api/order/export';
    static EXPORT_ORDER_ATTACHMENT = Helper.getOrderUrl() + '/api/order/exportOrderEmail';
    static ORDER_EXPORT_COUNT = Helper.getOrderUrl() + '/api/order/getCount';
    static ORDER_MANUFACTURE_LIST = Helper.getOrderUrl() + '/api/order/orderManufactureList';
    static ORDER_LINE_ITEM_WISE_EMAIL = Helper.getOrderUrl() + '/api/order/lineItemwiseEmail';
    static ORDER_PO_LINE_ITEM_EMAIL = Helper.getOrderUrl() + '/api/order/sendOrderPOItemEmail';
    static ORDER_REASON_RETURN_LIST = Helper.getOrderUrl() + '/api/order/orderReturnReasons';
    static ORDER_RETURN_REQUEST = Helper.getOrderUrl() + '/api/order/orderReturnRequest';
    static SCHEDULE_ORDER_REPORT = Helper.getOrderUrl() + '/api/order/scheduleOrderReport';
    static GET_ORDER_REPORTS = Helper.getOrderUrl() + '/api/order/scheduleOrderReports';
    static DELETE_ORDER_REPORTS = Helper.getOrderUrl() + '/api/order/scheduleOrderReport';
    static getOrderRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/orders';
    }

    static getOrderDetailRouteURL(extra_c = {}) {
        c[Common.param_key] = Common.chain.OrderDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getOrderDetailTabsListRouteURL(extra_c = {}) {
        c[CommonOrderDetail.param_key_OrderDetailTabList] = CommonOrderDetail.chain.OrderDetailTabsListing.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getOrderHistoryRouteURL() {
        let c_h = {}
        c_h[Common.param_key] = Common.chain.OrderHistory.param_value;
        return this.getURLBasedOnParamKey(c_h);
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/my-avnet/orders?' + $.param(c);
    }
}

export default Order;